export enum Page{
    Home = "Home",
    Results = "Results",
    LearningAimDetails = "LearningAimDetails",
    Pathway = "Pathway",
    Category = "Category",
    CommonComponent = "CommonComponent",
    Standard = "Standard",
    RelatedLearningAims = "RelatedLearningAims"
}